import Mustache from 'mustache'
import partial from 'lodash/partial'
import { formatDateTime, formatDateWithLocale } from '~/common/tzUtils'
import { formatCurrency } from '~/common/currencyUtils'

/**
 * Registry of all Mustache lambdas that we support for formatting activity log messages.
 */
const LAMBDAS = ({ timezone, locale }) => ({
  // These names must be kept in sync with the Python impls

  /**
   * Localizes an iso date string
   */
  iso_date_to_local() {
    return (rawDate, render) => {
      if (rawDate == null) return ''
      return formatDateWithLocale(render(rawDate), locale, timezone, { time: {} })
    }
  },
  /**
   * Localizes an iso datetime string
   */
  iso_datetime_to_local() {
    return (rawDate, render) => {
      return renderedDate(render(rawDate), partial(formatDateTime, partial.placeholder, timezone, locale))
    }
  },
  /**
   * Formats currency
   */
  currency() {
    return (rawNumber, render) => {
      return formatCurrency(render(rawNumber))
    }
  }
})

export function renderLogMessage(activity_log, timezone, locale) {
  const details = activity_log.details || {}
  if (activity_log.template_log) {
    return Mustache.render(activity_log.template_log, { ...details, ...LAMBDAS({ timezone, locale }) })
  }
  return activity_log.log
}

function renderedDate(d, formatFunc) {
  if (!d) return ''
  return formatFunc(d)
}
